import { MappedServiceType } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import { SERVICE_KEY_BY_TYPE, ServiceKey } from '@/constants/common';

export const EMPTY_BALANCE_CODE = ['EMPTY_BALANCE'] as const;

export const WALLET_METHOD_ID = 'wallet';

export const MAPPED_TYPE_TO_SERVICE_KEY: Record<MappedServiceType, ServiceKey> =
  {
    bump: SERVICE_KEY_BY_TYPE.BUMP,
    featured: SERVICE_KEY_BY_TYPE.FEATURED
  };
